import React, { useState } from 'react';
import './Auth.css';

function PhoneInput({ label, name, value, onChange, error, required = false, disabled = false }) {
  const [countryCode, setCountryCode] = useState('+91');

  const countryCodes = [
    { code: '+1', country: 'US/CA' },
    { code: '+7', country: 'RU' },
    { code: '+20', country: 'EG' },
    { code: '+27', country: 'ZA' },
    { code: '+30', country: 'GR' },
    { code: '+31', country: 'NL' },
    { code: '+32', country: 'BE' },
    { code: '+33', country: 'FR' },
    { code: '+34', country: 'ES' },
    { code: '+36', country: 'HU' },
    { code: '+39', country: 'IT' },
    { code: '+40', country: 'RO' },
    { code: '+41', country: 'CH' },
    { code: '+43', country: 'AT' },
    { code: '+44', country: 'UK' },
    { code: '+45', country: 'DK' },
    { code: '+46', country: 'SE' },
    { code: '+47', country: 'NO' },
    { code: '+48', country: 'PL' },
    { code: '+49', country: 'DE' },
    { code: '+51', country: 'PE' },
    { code: '+52', country: 'MX' },
    { code: '+53', country: 'CU' },
    { code: '+54', country: 'AR' },
    { code: '+55', country: 'BR' },
    { code: '+56', country: 'CL' },
    { code: '+57', country: 'CO' },
    { code: '+58', country: 'VE' },
    { code: '+60', country: 'MY' },
    { code: '+61', country: 'AU' },
    { code: '+62', country: 'ID' },
    { code: '+63', country: 'PH' },
    { code: '+64', country: 'NZ' },
    { code: '+65', country: 'SG' },
    { code: '+66', country: 'TH' },
    { code: '+81', country: 'JP' },
    { code: '+82', country: 'KR' },
    { code: '+84', country: 'VN' },
    { code: '+86', country: 'CN' },
    { code: '+90', country: 'TR' },
    { code: '+91', country: 'IN' },
    { code: '+92', country: 'PK' },
    { code: '+93', country: 'AF' },
    { code: '+94', country: 'LK' },
    { code: '+95', country: 'MM' },
    { code: '+98', country: 'IR' },
    { code: '+212', country: 'MA' },
    { code: '+213', country: 'DZ' },
    { code: '+216', country: 'TN' },
    { code: '+218', country: 'LY' },
    { code: '+220', country: 'GM' },
    { code: '+234', country: 'NG' },
    { code: '+254', country: 'KE' },
    { code: '+351', country: 'PT' },
    { code: '+352', country: 'LU' },
    { code: '+353', country: 'IE' },
    { code: '+354', country: 'IS' },
    { code: '+355', country: 'AL' },
    { code: '+356', country: 'MT' },
    { code: '+357', country: 'CY' },
    { code: '+358', country: 'FI' },
    { code: '+370', country: 'LT' },
    { code: '+371', country: 'LV' },
    { code: '+372', country: 'EE' },
    { code: '+373', country: 'MD' },
    { code: '+374', country: 'AM' },
    { code: '+375', country: 'BY' },
    { code: '+380', country: 'UA' },
    { code: '+381', country: 'RS' },
    { code: '+385', country: 'HR' },
    { code: '+420', country: 'CZ' },
    { code: '+421', country: 'SK' },
    { code: '+880', country: 'BD' },
    { code: '+960', country: 'MV' },
    { code: '+961', country: 'LB' },
    { code: '+962', country: 'JO' },
    { code: '+963', country: 'SY' },
    { code: '+964', country: 'IQ' },
    { code: '+965', country: 'KW' },
    { code: '+966', country: 'SA' },
    { code: '+967', country: 'YE' },
    { code: '+968', country: 'OM' },
    { code: '+971', country: 'AE' },
    { code: '+972', country: 'IL' },
    { code: '+973', country: 'BH' },
    { code: '+974', country: 'QA' },
    { code: '+977', country: 'NP' },
  ];

  const handlePhoneChange = (e) => {
    const phoneValue = e.target.value.replace(/\D/g, '');
    onChange({ target: { name, value: phoneValue } });
  };

  return (
    <div className="input-group">
      <label className="input-label">
        {label}{required && <span className="required">*</span>}
      </label>
      <div className="phone-input-wrapper">
        <select 
          className="country-code-select" 
          value={countryCode}
          onChange={(e) => setCountryCode(e.target.value)}
          disabled={disabled}
        >
          {countryCodes.map((country) => (
            <option key={country.code} value={country.code}>
              {country.code}
            </option>
          ))}
        </select>
        {/* FIXED: Wrapped input in a div with class "phone-input" */}
        <div className="phone-input">
          <input
            type="tel"
            name={name}
            placeholder="0000000000"
            value={value}
            onChange={handlePhoneChange}
            disabled={disabled}
            maxLength="15"
            className={`input-field ${error ? 'input-error' : ''}`}
          />
        </div>
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
}

export default PhoneInput;
